import { DEFAULT_LOCALE } from "@adpilot/shared";
import i18n, { type Resource, type ResourceLanguage } from "i18next";
import { initReactI18next } from "react-i18next";

/**
 * 翻译资源按「locale/namespace.json」组织（namespace = 业务领域）。
 * 通过 glob 自动装载，新增领域只需添加 en-US/xx.json + zh-CN/xx.json，
 * 无需改动本文件；两个 locale 的 key 对齐由 locales.test.ts 保证。
 */
const localeModules = import.meta.glob<Record<string, unknown>>("./locales/*/*.json", {
  eager: true,
  import: "default",
});

const resources: Resource = {};
for (const [path, translations] of Object.entries(localeModules)) {
  const match = path.match(/\.\/locales\/([^/]+)\/([^/]+)\.json$/);
  if (!match) continue;
  const lng = match[1];
  const ns = match[2];
  if (!lng || !ns) continue;
  let bucket = resources[lng];
  if (!bucket) {
    bucket = {};
    resources[lng] = bucket;
  }
  (bucket as ResourceLanguage)[ns] = translations;
}

const isDev = import.meta.env.DEV || import.meta.env.MODE === "test";

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: DEFAULT_LOCALE,
  defaultNS: "common",
  interpolation: {
    // React 已做 XSS 转义
    escapeValue: false,
  },
  returnNull: false,
  // 缺失 key：开发/测试环境可观察（console.warn），生产静默 fallback 到 DEFAULT_LOCALE
  saveMissing: isDev,
  missingKeyHandler: (lngs, ns, key) => {
    console.warn(`[i18n] Missing translation key: ${ns}:${key} (${lngs.join(", ")})`);
  },
});

export { i18n };

if (import.meta.hot) {
  // Locale edits must replace i18next's singleton resource store and already-mounted labels.
  import.meta.hot.accept(() => window.location.reload());
}
